import { IPanelStyles } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { BoxShadowPanel, FontSizes, FontWeights, Sizes } from '../../themes/styles';

const padding = 24;
export const panelStylesDefault = (theme: IH2OTheme): Partial<IPanelStyles> => ({
  main: {
    backgroundColor: theme.palette?.white,
    border: `1px solid ${theme.palette?.gray300}`,
    boxShadow: BoxShadowPanel,
    borderRadius: Sizes.borderRadius,
  },
  commands: {
    backgroundColor: 'transparent !important',
    paddingTop: padding,
    marginTop: 0,
  },
  headerText: {
    fontWeight: FontWeights.normal,
    color: theme.semanticColors?.textQuaternary,
    lineHeight: 24,
    paddingBottom: 8,
  },
  scrollableContent: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  content: {
    flex: 1,
    paddingBottom: padding,
    overflow: 'auto',
  },
  closeButton: {
    fontSize: FontSizes.small,
    height: 24,
    width: 24,
    marginRight: 20,
  },
  footer: {
    backgroundColor: 'transparent !important',
    borderTop: `1px solid ${theme.palette?.gray300}`,
  },
  footerInner: {
    padding: 24,
    paddingTop: 16,
    textAlign: 'right',
  },
});
